import type { MDXComponents } from "mdx/types";

import { Text } from "@/components/elements/Text";

const H1 = ({ children }) => (
  <Text as="h1" size="xl">
    {children}
  </Text>
);

const H2 = ({ children }) => (
  <Text as="h2" size="l" style={{ marginLeft: 0 }}>
    {children}
  </Text>
);

const H3 = ({ children }) => (
  <Text as="h3" size="l" style={{ marginLeft: 0 }}>
    {children}
  </Text>
);

export function useMDXComponents(components: MDXComponents): MDXComponents {
  return {
    h1: H1,
    h2: H2,
    h3: H3,
    p: Text,
    ...components,
  };
}
